// Shared helpers used by the schedule page and its admin counterpart.
// Date, time, week-range, and location-parsing utilities.

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function toDateStr(date) {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  return `${y}-${m}-${d}`;
}

export function parseDateOnly(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0, 0);
  }

  if (typeof value === "string") {
    const match = value.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, y, m, d] = match;
      return new Date(Number(y), Number(m) - 1, Number(d), 0, 0, 0, 0);
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate(), 0, 0, 0, 0);
}

export function parseDateTime(dateStr, timeStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const [hh, mm] = String(timeStr).slice(0, 5).split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, 0, 0);
}

export function startOfWeekMonday(d) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  date.setDate(date.getDate() + diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function endOfWeekSunday(d) {
  const start = startOfWeekMonday(d);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return end;
}

export function formatNiceDate(date) {
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

export function formatNiceTime(date) {
  return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function isWithin(now, start, end) {
  return now >= start && now <= end;
}

export function fromDbTime(t) {
  if (!t) return "";
  return String(t).slice(0, 5);
}

export function toDbTime(t) {
  if (!t) return "";
  const s = String(t);
  return s.length === 5 ? `${s}:00` : s; // "HH:mm" -> "HH:mm:00"
}

export function pointToLatLng(value) {
  if (!value) return { lat: "", lng: "" };
  if (typeof value === "string") {
    const match = value.match(/POINT\(([-\d.]+)\s+([-\d.]+)\)/i);
    if (match) return { lng: match[1], lat: match[2] };
    return { lat: "", lng: "" };
  }
  if (typeof value !== "object") return { lat: "", lng: "" };
  if (("lat" in value || "lng" in value) && (value.lat != null || value.lng != null)) {
    return { lat: value.lat, lng: value.lng };
  }
  if (("x" in value || "y" in value) && (value.x != null || value.y != null)) {
    return { lng: value.x, lat: value.y };
  }
  if ("coords" in value) return pointToLatLng(value.coords);
  return { lat: "", lng: "" };
}

export function googleMapsLink(address, lat, lng) {
  if (lat && lng) {
    return `https://www.google.com/maps?q=${encodeURIComponent(`${lat},${lng}`)}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || "")}`;
}
